module.exports = __webpack_public_path__ + "img/banner2.29fb50b8.png";